
<div class="border-0 px-4 py-1 scroll-container" ref="RolesManagement">
  <p class="page-title mt-3 fs-6 fw-bold">Roles Management</p>
  <!-- Roles Created Card (ONLY SHOW WHEN NOT MANAGING A ROLE) -->
  <div v-if="!is_managing_role">
    <div class="row">
      <div class="col-md-4">
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center gap-3 py-3 px-3 justify-content-between">
            <!-- Text on the left -->
            <div class="d-flex flex-column justify-content-center text-start">
              <p class="mb-1 text-xs text-white">Roles Created</p>
              <p class="m-0 fw-bold text-white">{{ roles.length }}</p>
            </div>
            <!-- Icon on the right -->
            <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
              <i class="fas fa-user-shield fa-lg text-primary-blue"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- New Role Button (Only before clicking Manage Role) -->
  <div v-if="!is_managing_role">

    <div class="glassy-table rounded-lg border-0 mt-4 shadow">
      <div class="card-body">
          <div class="d-block text-end">
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow mb-2" data-bs-toggle="modal" data-bs-target="#create_role" >
              New Role
          </button>
          </div>
          <GlobalTable
            v-if="roles.length > 0"
            :headers="roles_headers"
            :data="roles"
            table_id="role_management_table">
            <template #actions="{ row }">
              <button
                v-if="!delete_only && is_super_user===true"
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                data-bs-toggle="modal"
                data-bs-target="#assign_projects"
                @click="get_assignments(row.id)">
                Assign
              </button>
              <button
                v-else-if="row.role !== 'System Admin' && row.role !== 'Lead'"
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                @click="unassign_role_from_project(row.id, row.role)">
                Delete
              </button>
            </template>
          </GlobalTable>
      </div>
    </div>
  </div>
  <!-- Tabs Outside the Card -->
  <div class="card card-nav-tabs border-0 shadow rounded-lg mt-5">
  <div v-if="is_managing_role" class="card-header card-header-primary rounded-lg border-0">
    <div class="nav-tabs-navigation">
      <div class="nav-tabs-wrapper">
          <ul class="nav nav-tabs" data-tabs="tabs">
              <li class="nav-item " :class="{'active-tab': is_role_permission_active , 'active': active_tab === tab }"
              @click="toggleTab('permission')">
                  <a class="text-white text-decoration-none text-x nav-link" href="#profile" data-toggle="tab">
                    Role Permission Management
                  </a>
              </li>
              <li class="nav-item " :class="{'active-tab': is_role_user_active}"
                  @click="toggleTab('user')">
                  <a class="text-white text-decoration-none text-x nav-link" href="#profile" data-toggle="tab">
                    Role User Management
                  </a>
              </li>
          </ul>
      </div>
  </div>
  </div>

      <!-- Show Manage Role Section when managing a role -->
      <div v-if="is_managing_role">
        <!-- Tab Content -->
        <div v-if="is_role_permission_active">
          <!-- Role Permission Management Content -->

            <div class="card-body">
              <div class="d-flex align-items-center">
                <h6 class="text-xxs fw-bold">Role Name: {{ current_role.role_type }}</h6>
              </div>
              <!-- Buttons placed between Portfolio Permissions and Entries per Page -->
              <div class="d-flex justify-content-start mt-3 mb-3">
                <button class="btn btn-primary-dark btn-sm rounded-small text-xxs text-dark me-2 shadow" @click="assign_permission">
                  <i class="bi bi-plus-circle"></i> Assign Permission
                </button>
                <button class="btn btn-primary-dark btn-sm rounded-small text-xxs text-dark shadow " @click="remove_policy">
                  <i class="bi bi-trash"></i> Remove Policy
                </button>
              </div>
                  <!-- Table (entries per page would be here) -->
                  <GlobalTable :headers="['No', 'Permission']" :data="roles_two" table_id="trust_pending_application" />

            </div>
          </div>
        </div>
      </div>
</div>


<!-- Create Role Modal -->
 <teleport to="body">
<div class="modal fade" id="create_role" tabindex="-1" aria-labelledby="create_role_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="create_role_label">Create Role</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <!-- <hr class="modal-hrr mb-3"> -->
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label for="role" class="modal-form-label form-label text-xxs">Role:</label>
          <input type="text" v-model="role_name" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" placeholder="Enter Role Name">
          <small class="text-danger p-2 text-xxs fw-bold d-none project-name-messages">Please enter a role name</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label for="description" class="modal-form-label form-label text-xxs">Description:</label>
          <input type="text" v-model="role_description" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" placeholder="Enter Description">
          <small class="text-danger p-2 text-xxs fw-bold d-none project-description-messages">Please enter a description</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
      </div>
      <!-- <hr class="modal-hrr mb-3"> -->
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="submit" class="btn btn-primary-dark btn-sm text-xxs mt-3 text-dark" @click="add_role">Save</button>
      </div>
    </div>
  </div>
</div>
 </teleport>


<!-- Assign Projects Modal -->
<teleport to="body">
<div class="modal fade" id="assign_projects" tabindex="-1" aria-labelledby="assign_projects_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="assign_projects_label">Assign Projects</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <!-- <hr class="modal-hrr mb-3"> -->
      <div class="modal-body">
        <GlobalTable
          v-if="project_list.length > 0"
          :headers="project_headers"
          :data="project_list"
          :key="project_list"
          table_id="project_assignment_table"
        >
          <template #actions="{ row }">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                :id="'switch_' + row.id"
                :checked="project_ids.includes(row.id)"
                @change="toggle_assignment(row.id)"
              >
              <label class="form-check-label" :for="'switch_' + row.id">
                {{ project_ids.includes(row.id) ? 'Assigned' : 'Unassigned' }}
              </label>
            </div>
          </template>
        </GlobalTable>
      </div>
      <!-- <hr class="modal-hrr mb-3"> -->
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="submit" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="assign_projects_to_role">Save</button>
      </div>
    </div>
  </div>
</div>
</teleport>